import { useUserStore } from '~/stores/user'

export default defineNuxtRouteMiddleware((to, _f) => {
  if (to.path.startsWith('/admin')) {
    const store = useUserStore()
    const ok = store.$state.user && store.$state.user.Site_Admin
    if (!ok) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  }

  if (
    to.path.startsWith('/head-office') ||
    to.path.startsWith('/marketing') ||
    to.path.startsWith('/warehouse')
  ) {
    const store = useUserStore()
    const ok =
      store.$state.user && (store.$state.user.Site_Admin || store.$state.user.Role === 'buyer')
    if (!ok) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  }

  if (to.path.startsWith('/fulfillment/admin')) {
    const store = useUserStore()
    const ok =
      store.$state.user && (store.$state.user.Site_Admin || store.$state.user.Role === 'buyer')
    if (!ok) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  } else if (to.path.startsWith('/fulfillment')) {
    if (to.params.env && to.params.env !== 'sandbox') {
      return abortNavigation(
        createError({ statusMessage: 'Not Found', statusCode: 404, fatal: true }),
      )
    }
    const store = useUserStore()
    const start =
      to.params.env && to.params.env === 'sandbox' ? '/fulfillment/sandbox' : '/fulfillment'
    if (store.$state.user && (store.$state.user.Role == 'buyer' || store.$state.user.Site_Admin)) {
      return
    }
    const perms = store.$state.user ? store.$state.user.Permissions : {}
    if (
      to.path === start &&
      store.$state.user &&
      (perms['fulfillment'] || perms['team fulfillment'])
    ) {
      return
    }
    if (to.path.startsWith(`${start}/team-quotes`) && perms['team fulfillment']) {
      return
    }
    if (to.path.startsWith(`${start}/accounting`) && perms['accounting']) {
      return
    }
    if (to.path.startsWith(`${start}/analytics`) && perms['fulfillment'] && perms['sales']) {
      return
    }
    if (!perms['fulfillment']) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  }

  if (to.path.startsWith('/show')) {
    const store = useUserStore()
    const ok =
      store.$state.user &&
      (store.$state.user.Role == 'buyer' ||
        store.$state.user.Site_Admin ||
        (store.$state.user.Role == 'member' && store.$state.user.Permissions['show data']))
    if (!ok) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  }

  if (to.path.startsWith('/open-to-buy')) {
    const store = useUserStore()
    const ok =
      store.$state.user &&
      (store.$state.user.Role == 'buyer' ||
        store.$state.user.Site_Admin ||
        (store.$state.user.Role == 'member' && store.$state.user.Permissions['sales']))
    if (!ok) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  }

  if (to.path.startsWith('/specials')) {
    const store = useUserStore()
    const ok =
      store.$state.user &&
      (store.$state.user.Role == 'buyer' ||
        store.$state.user.Site_Admin ||
        (store.$state.user.Role == 'member' && store.$state.user.Permissions['ordering']))
    if (!ok) {
      return abortNavigation(
        createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
      )
    }
  }
})
